function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4863 81.6406C13.9303 69.0846 11.7254 50.0972 19.8718 35.2825L41.9023 57.313L57.313 41.9022L35.2825 19.8717C50.0972 11.7254 69.0846 13.9302 81.6406 26.4862C93.5974 38.443 96.1674 56.2321 89.3506 70.6961L196.207 177.553C201.247 182.592 201.247 190.763 196.207 195.802C191.168 200.842 182.997 200.842 177.958 195.802L71.2429 89.0876C56.6827 96.2308 38.5942 93.7485 26.4863 81.6406ZM191.341 180.797C194.14 183.597 194.14 188.136 191.341 190.936C188.541 193.735 184.002 193.735 181.202 190.936C178.402 188.136 178.402 183.597 181.202 180.797C184.002 177.997 188.541 177.997 191.341 180.797Z",
  fill: "#D9D9D9"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M165.337 41.6361L82.6766 123.513L100.636 141.529L182.753 58.0312L194.877 55.9433C195.489 55.838 196.007 55.5251 196.378 55.0922L196.492 55.1523L221.3 18.836L221.641 18.4892L205.109 1.84961L204.891 2.06863L167.808 28.0623C167.606 28.2043 167.484 28.419 167.454 28.6467C167.431 28.7033 167.414 28.7631 167.404 28.8255L165.337 41.6361Z",
  fill: "#008C85"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7139 114.759C62.6148 110.858 68.9394 110.858 72.8403 114.759L109.243 151.162C113.144 155.062 113.144 161.387 109.243 165.288C105.342 169.189 99.0173 169.189 95.1165 165.288L58.7139 128.885C54.813 124.984 54.813 118.66 58.7139 114.759Z",
  fill: "#008C85"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.358 150.78L72.6922 143.114L29.3123 186.494L23.5631 180.745L66.943 137.365L58.34 128.762L35.9203 151.182L25.0277 157.588L25.4937 157.856C23.5991 158.451 21.816 159.499 20.3145 161.001L5.67629 175.639C0.701657 180.614 0.701651 188.679 5.67628 193.654L30.0142 217.992C34.9888 222.966 43.0543 222.966 48.0289 217.992L62.6671 203.354C64.1619 201.859 65.2076 200.085 65.8041 198.2L66.0272 198.587L71.7552 188.847L95.0901 165.512L86.1072 156.529L42.7258 199.911L36.9766 194.162L80.358 150.78Z",
  fill: "#008C85"
});
function SvgActionItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionItem);
export default __webpack_public_path__ + "static/media/action-item.1ea593cee5bf3036eb61435c7fcf831f.svg";
export { ForwardRef as ReactComponent };